let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ftJgg"), load("b8oHe")]).then(() => parcelRequire('1Q21q'));